import { Component, Input, OnChanges, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AggregationResult } from '../../model/everything-search-result';
import { EntityType } from "../../model/search-constants";
import { AggregationKeyValuePipe } from '../../pipe/aggregation-key-value.pipe';
import { EntityTypePipe } from '../../pipe/entity-type.pipe';
import { KeyValueCount } from '../../utils/key-value-count';
import { SearchFilterValueListComponent } from '../search-filter-value-list/search-filter-value-list.component';

@Component({
  selector: 'app-search-filter-entity-type',
  templateUrl: './search-filter-entity-type.component.html',
  styleUrls: [ './search-filter-entity-type.component.scss' ],
  imports: [ SearchFilterValueListComponent, AggregationKeyValuePipe ]
})
export class SearchFilterEntityTypeComponent implements OnChanges {
  @Input() aggregation: AggregationResult[];
  @Output() visible = new BehaviorSubject<boolean>(false);
  keyValues: KeyValueCount[] = [];
  pipe = new EntityTypePipe();

  ngOnChanges() {
    if (!this.aggregation) return;
    this.aggregation = this.aggregation.filter(it => it.value !== EntityType.FEED)
  }
}
